// extracted by mini-css-extract-plugin
module.exports = {"date":"NewArticles-module--date--2iNGe","link":"NewArticles-module--link--1tt1R"};